export default {
    services: {
        _SESION: {
            token: "",
            role: "",
            id: "",
            account_type: {
                type: "",
                owner: ""
            }
        },
        _PROFILE: {
            first_name: "",
            last_name: "",
            image: ""
        },
        _RESPONSE: {
            count: 0,
            next: "",
            previous: "",
            page: 0,
            pages: 0,
            docs: []
        },
        unauthorizedAction: function(error) {
            if (error.response) {
                let { data } = error.response;
                if (data.code === 401) {
                    return true;
                } else {
                    return false;
                }
            } else if (error.request) {
                return false;
            } else {
                return false;
            }
        },
        getTimes: function() {
            let intervals = [];
            for (let index = 0; index < 24; index++) {
                let min = 0;
                while (min < 60) {
                    if (index >= 0 && index <= 11) {
                        if (index === 0) {
                            if (min.toString().length < 2) {
                                intervals.push({
                                    value: `12:0${min} AM`,
                                    label: `12:0${min} AM`
                                });
                            } else {
                                intervals.push({
                                    value: `12:${min} AM`,
                                    label: `12:${min} AM`
                                });
                            }
                        } else {
                            if (min.toString().length < 2 && index.toString().length < 2) {
                                intervals.push({
                                    value: `0${index}:0${min} AM`,
                                    label: `0${index}:0${min} AM`
                                });
                            } else if (
                                min.toString().length > 1 &&
                                index.toString().length < 2
                            ) {
                                intervals.push({
                                    value: `0${index}:${min} AM`,
                                    label: `0${index}:${min} AM`
                                });
                            } else if (
                                min.toString().length < 2 &&
                                index.toString().length > 1
                            ) {
                                intervals.push({
                                    value: `${index}:0${min} AM`,
                                    label: `${index}:0${min} AM`
                                });
                            } else {
                                intervals.push({
                                    value: `${index}:${min} AM`,
                                    label: `${index}:${min} AM`
                                });
                            }
                        }
                    } else {
                        let indexPM = index - 12;
                        if (indexPM === 0) {
                            if (min.toString().length < 2) {
                                intervals.push({
                                    value: `12:0${min} PM`,
                                    label: `12:0${min} PM`
                                });
                            } else {
                                intervals.push({
                                    value: `12:${min} PM`,
                                    label: `12:${min} PM`
                                });
                            }
                        } else {
                            if (min.toString().length < 2 && indexPM.toString().length < 2) {
                                intervals.push({
                                    value: `0${indexPM}:0${min} PM`,
                                    label: `0${indexPM}:0${min} PM`
                                });
                            } else if (
                                min.toString().length > 1 &&
                                indexPM.toString().length < 2
                            ) {
                                intervals.push({
                                    value: `0${indexPM}:${min} PM`,
                                    label: `0${indexPM}:${min} PM`
                                });
                            } else if (
                                min.toString().length < 2 &&
                                indexPM.toString().length > 1
                            ) {
                                intervals.push({
                                    value: `${indexPM}:0${min} PM`,
                                    label: `${indexPM}:0${min} PM`
                                });
                            } else {
                                intervals.push({
                                    value: `${indexPM}:${min} PM`,
                                    label: `${indexPM}:${min} PM`
                                });
                            }
                        }
                    }

                    min = min + 5;
                }
            }
            return intervals;
        },
        back(self) {
            if (window.history.length > 1) {
                self.$router.go(-1);
            } else {
                self.$router.push('/');
            }
        }
    }
}